/**
 * Debug日志工具
 * 只在开发环境和staging环境输出日志
 */

/**
 * 检查是否应该输出日志
 * @returns {boolean}
 */
const shouldLog = () => {
  return (
    process.env.NODE_ENV === "development" ||
    window.location.href.includes("website-stage.") ||
    window.location.href.includes("localhost")
  );
};

/**
 * 普通日志输出
 * @param {string} name - 日志名称
 * @param {object} parameters - 日志参数
 */
export function caloDebugLog(name, parameters = {}) {
  if (shouldLog()) {
    console.log(`[Calo] ${name}`, parameters);
  }
}

/**
 * 警告日志输出
 * @param {string} name - 日志名称
 * @param {object} parameters - 日志参数
 */
export function caloDebugWarn(name, parameters = {}) {
  if (shouldLog()) {
    console.warn(`[Calo] ${name}`, parameters);
  }
}

/**
 * 错误日志输出
 * @param {string} name - 日志名称
 * @param {object} parameters - 日志参数
 */
export function caloDebugError(name, parameters = {}) {
  if (shouldLog()) {
    console.error(`[Calo] ${name}`, parameters);
  }
}

/**
 * 调试日志输出（带堆栈信息）
 * @param {string} name - 日志名称
 * @param {object} parameters - 日志参数
 */
export function caloDebugTrace(name, parameters = {}) {
  if (shouldLog()) {
    console.trace(`[Calo] ${name}`, parameters);
  }
}

/**
 * 分组日志开始
 * @param {string} name - 分组名称
 */
export function caloDebugGroup(name) {
  if (shouldLog()) {
    console.group(`[Calo] ${name}`);
  }
}

/**
 * 分组日志结束
 */
export function caloDebugGroupEnd() {
  if (shouldLog()) {
    console.groupEnd();
  }
}

/**
 * 表格形式输出
 * @param {string} name - 日志名称
 * @param {array|object} data - 数据
 */
export function caloDebugTable(name, data) {
  if (shouldLog()) {
    console.log(`[Calo] ${name}`);
    console.table(data);
  }
}

// 暴露到window对象，方便在浏览器控制台调试
if (typeof window !== "undefined") {
  window.caloDebugLog = caloDebugLog;
  window.caloDebugWarn = caloDebugWarn;
  window.caloDebugError = caloDebugError;
  window.caloDebugTrace = caloDebugTrace;
  window.caloDebugGroup = caloDebugGroup;
  window.caloDebugGroupEnd = caloDebugGroupEnd;
  window.caloDebugTable = caloDebugTable;
}
